import * as React from "react";
import ReactGridContainer from "components/common/ReactGridContainer";
import AggregationWidgetConfig from "views/logic/aggregationbuilder/AggregationWidgetConfig";
import WidgetCard from "views/components/widgets/WidgetCard";
import WidgetContentSkeleton from "views/components/widgets/WidgetContentSkeleton";
const COLUMNS = { xxl: 12, xl: 12, lg: 12, md: 12, sm: 12, xs: 12 };
const NOOP = () => {
};
const WelcomeSearchSkeleton = ({ entries }) => /* @__PURE__ */ React.createElement(
  ReactGridContainer,
  {
    columns: COLUMNS,
    positions: Object.fromEntries(entries.map(({ widget, position }) => [widget.id, position])),
    onPositionsChange: NOOP,
    isResizable: false,
    locked: true
  },
  entries.map(({ widget, title }) => /* @__PURE__ */ React.createElement("div", { key: widget.id }, /* @__PURE__ */ React.createElement(WidgetCard, { headline: title }, /* @__PURE__ */ React.createElement(
    WidgetContentSkeleton,
    {
      visualization: widget.config instanceof AggregationWidgetConfig ? widget.config.visualization : void 0
    }
  ))))
);
export default WelcomeSearchSkeleton;
